import React, { useEffect, useState } from 'react';
import { Card, Col, Row, Typography, message } from 'antd';
import axios from 'axios';
import { getTenants } from '../../services/tenantApi';
import { Link } from 'react-router-dom';
const { Title, Text } = Typography;

const TenantCardView = () => {
  const [tenants, setTenants] = useState([]);

  useEffect(() => {
    const fetchTenants = async () => {
      try {
        const res = await getTenants()
        setTenants(res);
      } catch (err) {
        message.error('Failed to fetch tenants');
      }
    };
    fetchTenants();
  }, []);

  return (
    <div style={{ padding: 24 }}>
      <Row gutter={[16, 16]}>
        {tenants.map((tenant) => (
          <Col key={tenant._id} xs={24} sm={12} md={8} lg={6}>
            <Card bordered hoverable style={{ height: '100%' }}>
              <Title level={5} style={{ marginBottom: 8 }}>
                {tenant.tenantName}
              </Title>
              <Text type="secondary">Owner: {tenant.ownerName}</Text>
              <div style={{ marginTop: 12 }}>
                <Link to={`/tenant/${tenant._id}`}>Show More</Link>
              </div>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default TenantCardView;
